module.exports = __webpack_public_path__ + "img/close.03810674.svg";